import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipOption, MatChipRemove, MatChipTrailingIcon } from '@angular/material/chips';
import { IconComponent } from '@libs/components/icons';
import { InputItemModel, InputValueType } from '@libs/form/models';
import { ValueFormatterService } from '../../../../services';

@Component({
  selector: 'ui-form-chip-control',
  templateUrl: './chip-control.component.html',
  styleUrls: ['./chip-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    IconComponent,
    MatChipOption,
    MatChipRemove,
    MatChipTrailingIcon,
  ],
})
export class ChipControlComponent {
  public config: InputSignal<InputItemModel> = input.required();
  public currentValue: InputSignal<InputValueType> = input();
  public disabled: InputSignal<boolean> = input(false);
  public opened: InputSignal<boolean> = input(false);
  public clear: OutputEmitterRef<void> = output();

  public valueFormatter: ValueFormatterService = inject(ValueFormatterService);

  public isActive: Signal<boolean> = computed(() => {
    return this.config().defaultValue !== this.currentValue() && !this.valueFormatter.isEmptyValue(this.config(), this.currentValue());
  });
}
